import React, { useEffect, useRef, useState } from 'react';
import { Table, Button, Space, Affix, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { FormData } from './form-data';
import { calculation, calculationForCreate } from './calculate-data';
import FieldData, { KEYS_OF_DATE, KEYS_OF_DATE_TIME } from './field-data';
import { Popup } from '~components';
import moment from 'moment';
import ApiServices from '~services';
import { DATE_FORMAT } from '~commons/constants';
import { addCont } from '../api-helper';

//DownloadOutlined
const DEFAULT_VALUE = FieldData({});

const ListContDetailUpdate = ({ onChange, formData, type, orderDetail, reload }) => {
  const [newCont, setNewCont] = useState(DEFAULT_VALUE);
  const formRef = useRef();
  const [data, setData] = useState([]);
  const [isVisiblePopup, setIsVisiblePopup] = useState(false); //fullAddress
  const [isLoading, setIsLoading] = useState(false); //fullAddress
  const [contTypes, setContTypes] = React.useState([]);
  const getContTypes = async (Query = null) => {
    try {
      const { data } = await ApiServices.getContTypes({ Query });
      const types = {};
      data.data.forEach((item) => {
        types[item.id] = item.name;
      });

      setContTypes(types);
    } catch (err) {
      console.error('ERR - Get Cont Types', err);
    }
  };
  const initListCont = () => {
    if (orderDetail?.listCont?.length) {
      const dataFormat = orderDetail.listCont.map((item, index) => {
        const date =
          item.book_DeliveryContRequestDate ||
          item.bill_LiftingLadenContRequestDate ||
          item.transit_Date;
        const cargoReadyDate = item.book_CargoReadyDate
          ? moment(item.book_CargoReadyDate).format(DATE_FORMAT)
          : null;
        return {
          ...item,
          key: index,
          cargoReadyDate,
          deliveryContRequestDate: moment(date).format(DATE_FORMAT),
        };
      });
      setData(dataFormat);
      submitData(dataFormat);
    }
  };
  useEffect(() => {
    initListCont();
  }, [orderDetail]);
  useEffect(() => {
    getContTypes();
  }, []);

  const onSubmitForm = () => {
    formRef.current.submitForm();
  };
  const submitData = (data) => {
    onChange && onChange(calculationForCreate(data));
  };
  const addData = async (cont) => {
    setIsLoading(true);

    KEYS_OF_DATE.forEach((item) => {
      cont[item] = cont[item] ? moment(cont[item]).format('YYYY-MM-DD') : null;
    });
    KEYS_OF_DATE_TIME.forEach((item) => {
      cont[item] = cont[item] ? moment(cont[item]).format() : null;
    });
    await addCont(
      {
        ...cont,
        orderNumber: data.length + 1,
        quantityCont: data.filter((item) => item.typeCont == cont.typeCont).length + 1,
      },
      orderDetail,
      reload,
      formData
    );
    setIsLoading(false);
    setIsVisiblePopup(false);
  };
  const deleteRow = async (record) => {
    if (record?.id) {
      try {
        const res = await ApiServices.deleteCont(record.id);
        if (res.data) {
          message.success('Xoá cont thành công!');
          setIsLoading(true);
          reload();
        }
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    }
  };

  const formatData = calculation(data, contTypes);
  //calculationForCreate
  const columns = [
    {
      title: 'STT',
      dataIndex: 'orderNumber',
    },
    {
      title: 'Số lượng cont',
      dataIndex: 'quantityCont',
    },
    {
      title: 'Loại Cont',
      dataIndex: 'typeCont',
    },
    {
      title: 'Ngày yêu cầu giao cont',
      dataIndex: 'deliveryContRequestDate',
    },
    {
      title: 'Trọng tải',
      dataIndex: 'cargoWeight',
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <Space size='middle'>
          <a onClick={() => deleteRow(record)}>Xoá</a>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Affix offsetTop={30} className='space-align-block'>
        <Space align='center'>
          <Button
            type='primary'
            shape='round'
            icon={<PlusOutlined />}
            onClick={() => setIsVisiblePopup(true)}
          >
            Thêm Mới
          </Button>
        </Space>
      </Affix>

      <Table
        columns={columns}
        dataSource={formatData}
        bordered
        loading={isLoading}
        scroll={{ x: '100%', y: '100%' }}
        pagination={false}
      />

      <Popup
        title='Thêm mới Cont'
        visible={isVisiblePopup}
        closeModel={() => setIsVisiblePopup(false)}
        onSubmit={() => onSubmitForm()}
        body={
          <FormData
            type={type}
            infoData={formData}
            ref={formRef}
            fields={newCont}
            onSubmit={addData}
            onChange={setNewCont}
          />
        }
      />
    </>
  );
};
export { ListContDetailUpdate };
